import script from "./DetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsModal.vue?vue&type=style&index=0&id=0c81191f&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c81191f"]])

export default __exports__